import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import Home from './Pages/Home';
import Login from './Pages/Login';
import Layout from './Pages/Layout';
import HomeDashboard from './Pages/HomeDashboard';
import Help from './Pages/Help';
import Lesson from './Pages/Lesson';
import Signup from './Pages/Signup';
import Course from './Pages/Course';
import { useSelector } from 'react-redux';
import FinalExam from './Pages/FinalExam';

function RoutesPage() {
    const userinfo = useSelector((state) => state.auth);

  return (
    <Routes>
      <Route path="/" element={userinfo.access_token?<HomeDashboard/>:<Login />} />
      {/* <Route path="/home" element={<Home />} /> */}
      <Route path="/signup" element={<Signup />} />
      
      {/* Dashboard Route with Nested Routes */}
      <Route path="/dashboard" element={<HomeDashboard />}>
        <Route path="Dashboard" element={<HomeDashboard />} />
        <Route path="help" element={<Help />} />
        <Route path="lesson/:id" element={<Lesson />} />
        <Route path="course_details/:id" element={<Course />} /> {/* Nested path */}
      </Route>

      {/* Direct Course Details Path (if needed outside of /dashboard) */}
      <Route path="course_details/:id" element={<Course />} /> {/* Optional, if you want a direct route */}
          <Route path="final-exam" element={<FinalExam />} />

    </Routes>
  );
}

export default RoutesPage;
